import { Box, Button, ButtonGroup, Stack } from '@mui/material';

export type TimelineOption = 'today' | '3days' | 'week' | 'month' | '3months' /* | '6months' | 'year' */;

interface TimelineLabelProps {
    fullText: string;
    shortText: string;
}

interface TimeLineSelectorProps {
    selectedTimeline: TimelineOption;
    setSelectedTimeline: (timeline: TimelineOption) => void;
}

// Timeline option data with full and abbreviated labels
const timelineOptions: { labels: TimelineLabelProps; value: TimelineOption }[] = [
    { labels: { fullText: 'Today', shortText: 'Day' }, value: 'today' },
    { labels: { fullText: '3 Days', shortText: '3D' }, value: '3days' },
    { labels: { fullText: 'Week', shortText: 'Wk' }, value: 'week' },
    { labels: { fullText: 'Month', shortText: 'Mo' }, value: 'month' },
    { labels: { fullText: '3 Months', shortText: '3M' }, value: '3months' },
    // { value: '6months', labels: { fullText: '6 Months', shortText: '6M' } },
    // { value: 'year', labels: { fullText: 'Year', shortText: 'Yr' } },
];

export function TimelineSelector({ selectedTimeline, setSelectedTimeline }: Readonly<TimeLineSelectorProps>) {
    return (
        <Stack direction="row" sx={{ justifyContent: 'center', mb: 2 }}>
            <ButtonGroup size="small" variant="outlined">
                {timelineOptions.map((option) => (
                    <Button
                        key={option.value}
                        onClick={() => setSelectedTimeline(option.value)}
                        sx={{
                            '&:hover': {
                                backgroundColor: selectedTimeline === option.value ? 'primary.dark' : 'action.hover',
                            },
                            backgroundColor: selectedTimeline === option.value ? 'primary.main' : 'transparent',
                            color: selectedTimeline === option.value ? 'primary.contrastText' : 'text.primary',
                        }}
                    >
                        <Box sx={{ display: { sm: 'block', xs: 'none' } }}>{option.labels.fullText}</Box>
                        <Box sx={{ display: { sm: 'none', xs: 'block' } }}>{option.labels.shortText}</Box>
                    </Button>
                ))}
            </ButtonGroup>
        </Stack>
    );
}
